/**
 * WordPress dependencies
 */
import { getContext, store } from '@wordpress/interactivity';

// Interactivy store for the Popup Gallery block.
const { state, callbacks, actions } = store('itp/popup-gallery', {
  actions: {
    updateAdvert(size) {
      window.googletag.cmd.push(() => {
        window.googletag.destroySlots([window.mediaPressAdsSlots.gallery_mpu]);

        const adUnitPath = window.mediaPressAdsConfig.gptSlots.gallery_mpu.ad_unit_path
          ? window.mediaPressAdsConfig.gptSlots.gallery_mpu.ad_unit_path
          : '/21817151130/complexmiddleeast_en';

        window.mediaPressAdsSlots.gallery_mpu = window.googletag
          .defineSlot(adUnitPath, [size], 'gallery_mpu')
          .addService(window.googletag.pubads());

        window.googletag.display('gallery_mpu');
        window.googletag.pubads().refresh([window.mediaPressAdsSlots.gallery_mpu]);
      });
    },
    openPopup() {
      const context = getContext();
      state.selectedIndex = context?.index;
      state.isOpen = true;
      callbacks.updateUrl();
    },
    expandPopup() {
      state.isOpen = true;
      callbacks.updateUrl();
    },
    closePopup() {
      state.selectedIndex = 1;
      const currentPost = document.getElementById(`slide-${state?.selectedIndex}`);
      if (!currentPost) {
        return;
      }
      currentPost.scrollIntoView({
        behavior: 'instant',
        block: 'center',
        inline: 'start',
      });
      state.isOpen = false;
      callbacks.updateUrl();
    },
    scrollNext() {
      requestAnimationFrame(() => {
        const currentPost = document.getElementById(`slide-${state?.selectedIndex}`);
        if (!currentPost) {
          return;
        }

        const nextPost = currentPost.nextElementSibling;

        if (!nextPost) {
          return;
        }

        // Prevent overscroll on regular thumbnails
        if (state.selectedIndex === state.totalSlides - 3 && !state.isLargePreview) {
          return;
        }

        nextPost.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        });

        state.selectedIndex++;
        callbacks.updateUrl();
      });
    },
    scrollPrev() {
      requestAnimationFrame(() => {
        const currentPost = document.getElementById(`slide-${state?.selectedIndex}`);

        if (!currentPost) {
          return;
        }

        const previousPost = currentPost.previousElementSibling;

        if (!previousPost) {
          return;
        }

        previousPost.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        });

        state.selectedIndex--;
        callbacks.updateUrl();
      });
    },
    next() {
      if (state.selectedIndex === state.totalSlides) {
        return;
      }
      state.selectedIndex++;
      callbacks.updateUrl();
    },
    prev() {
      if (state.selectedIndex === 1) {
        return;
      }
      state.selectedIndex--;
      callbacks.updateUrl();
    },
  },
  callbacks: {
    init() {
      const url = new URL(window.location);

      const expanded = url.searchParams.get('popupExpanded');
      const popupSlide = url.searchParams.get('popupSlide');

      if (!expanded && popupSlide) {
        state.selectedIndex = 1;
        url.searchParams.set('popupSlide', state.selectedIndex);
        url.hash = 'popup-gallery';
        window.history.pushState({}, '', url.toString());
      }
    },
    isActiveIndex() {
      const context = getContext();
      if (state.selectedIndex === context.index) {
        context.isHidden = false;
      } else {
        context.isHidden = true;
      }
    },
    updateUrl() {
      const url = new URL(window.location);
      url.searchParams.set('popupSlide', state.selectedIndex);

      if (state.isOpen) {
        url.searchParams.set('popupExpanded', state.isOpen);
      } else {
        url.searchParams.delete('popupExpanded');
      }
      url.hash = 'popup-gallery';
      window.history.pushState({}, '', url.toString());
    },
    updateActiveIndexPopstate() {
      const url = new URL(window.location);

      const popupSlide = parseInt(url.searchParams.get('popupSlide') ?? 1, 10);

      const isOpen = url.searchParams.get('popupExpanded');

      state.selectedIndex = popupSlide;

      state.isOpen = isOpen;
    },
    controlsBlocked() {
      const { selectedIndex, totalSlides, isOpen, isLargePreview } = state;

      state.prevBlocked = selectedIndex === 1;

      if (isOpen && selectedIndex === totalSlides) {
        state.nextBlocked = true;
      } else if (!isOpen && isLargePreview && selectedIndex === totalSlides - 1) {
        state.nextBlocked = true;
      } else if (!isOpen && !isLargePreview) {
        state.nextBlocked = selectedIndex >= totalSlides - 3;
      } else {
        state.nextBlocked = false;
      }
    },
    hideSidebar() {
      if (state.selectedIndex === state.totalSlides) {
        state.sidebarHidden = true;
        state.replacedAdvert = true;
        actions.updateAdvert([300, 600]);
      } else {
        if (state.replacedAdvert) {
          state.replacedAdvert = false;
          actions.updateAdvert([300, 250]);
        }
        state.sidebarHidden = false;
      }
    },
  },
});
